var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIssue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3763 21.7508C25.3763 21.7508 23.7644 23.617 21.9519 23.617C20.1394 23.617 18.6814 21.8898 16.9018 21.8898C15.1221 21.8898 14.0902 22.7006 12.9909 23.8654M21.3974 4.17814L23.6156 6.39637C24.0875 6.86826 24.0875 7.63333 23.6156 8.10522L7.60521 24.1157C7.37861 24.3422 7.07126 24.4696 6.7508 24.4696H3.32422V21.043C3.32422 20.7225 3.45153 20.4151 3.67813 20.1886L19.6886 4.17814C20.1604 3.70625 20.9255 3.70625 21.3974 4.17814Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3763 21.7508C25.3763 21.7508 23.7644 23.617 21.9519 23.617C20.1394 23.617 18.6814 21.8898 16.9018 21.8898C15.1221 21.8898 14.0902 22.7006 12.9909 23.8654M21.3974 4.17814L23.6156 6.39637C24.0875 6.86826 24.0875 7.63333 23.6156 8.10522L7.60521 24.1157C7.37861 24.3422 7.07126 24.4696 6.7508 24.4696H3.32422V21.043C3.32422 20.7225 3.45153 20.4151 3.67813 20.1886L19.6886 4.17814C20.1604 3.70625 20.9255 3.70625 21.3974 4.17814Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssue);
export default __webpack_public_path__ + "static/media/report-issue.8e8319ebcb15876f85f607fe67604f3b.svg";
export { ForwardRef as ReactComponent };